import { CheckSolidV6, RepeatRegularV6 } from "@shared/v2/Icomoon";

import useBrand from "./useBrand";

const CARD_BASE =
  "tw-flex tw-flex-1 tw-basis-0 tw-items-center tw-justify-center tw-rounded-[12px] tw-bg-tinted-gray-50";

interface IntegrationDiagramProps {
  status: "syncing" | "live";
}

const IntegrationDiagram = ({ status }: IntegrationDiagramProps) => {
  const BadgeIcon = status === "live" ? CheckSolidV6 : RepeatRegularV6;
  const { name: brandName, logo, logoClassName } = useBrand();

  return (
    <div className="tw-flex tw-gap-[8px]">
      <div className={`${CARD_BASE} tw-p-[28px]`}>
        <img src={logo} alt={brandName} className={`tw-block ${logoClassName}`} />
      </div>

      {/* Fixed-size connector: the badge overhangs the 41px arrow lane by design. */}
      <div className="tw-relative tw-h-[41px] tw-w-[76px] tw-shrink-0 tw-self-center">
        <div className="tw-absolute tw-left-0 tw-top-[20.5px] tw-h-[1px] tw-w-[74px] tw-bg-gray-15" />
        <div className="tw-absolute tw-left-[17.5px] tw-top-[0.5px] tw-rounded-full tw-border-2 tw-border-solid tw-border-gray-15 tw-bg-white tw-p-[10px]">
          <BadgeIcon size="xl" className="tw-block tw-text-gray-75" />
        </div>
      </div>

      <div className={`${CARD_BASE} tw-p-[10px]`}>
        <img
          src="/images/connect-logo.svg"
          alt="Connect Services"
          className="tw-block tw-h-[29px] tw-w-[143px]"
        />
      </div>
    </div>
  );
};

export default IntegrationDiagram;
